import { PriceRange, PricingType } from "./";

export enum PricingSummaryFields {
  single = "single",
  lower = "lower",
  upper = "upper",
}

export type OnPriceChange = (arg0: number) => void;

export type OnPriceRangeChange = (arg0: PriceRange) => void;

export type OnPhasePriceChange = (arg0: {
  pricingType: PricingType;
  field: PricingSummaryFields;
  value: number | null;
  phaseId: number;
}) => void;

export type MatterTemplateData = {
  practiceAreaId: number;
  title: string;
};
